import { ReactNode } from 'react';
import { ActorProfile } from '@mews-commander/data-access';
import { ContentSection, DividerList, LabeledListItem, LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { lt } from '@mews/framework';
import { Avatar, Stack } from '@optimus-web/core';

interface UserAvatarProps {
    name?: string | null;
    imageId?: string | null;
}

const UserAvatar = ({ name, imageId }: UserAvatarProps) => {
    const getAvatarSrc = useGetAvatarSrc();
    const avatarImage = getAvatarSrc(imageId);

    return (
        <Stack spacing="100" itemAlignment="center">
            <Avatar src={avatarImage} title={name || ''} size="small" />
            <span>{name}</span>
        </Stack>
    );
};

interface ActorProfilesSectionProps {
    title?: ReactNode;
    creatorProfile: Omit<ActorProfile, 'id'>;
    createdUtc: string;
    updaterProfile: Omit<ActorProfile, 'id'>;
    updatedUtc: string;
}

export const ActorProfilesSection = ({
    title = lt('ActivityLog'),
    createdUtc,
    creatorProfile,
    updatedUtc,
    updaterProfile,
}: ActorProfilesSectionProps) => (
    <ContentSection title={title}>
        <DividerList>
            <LabeledListItem label={lt('CreatedBy')} itemAlignment="center">
                <UserAvatar imageId={creatorProfile.imageId} name={creatorProfile.name} />
            </LabeledListItem>
            <LabeledListItem label={lt('CreatedOn')}>
                <LocalizedDateTimeFromUtc utcString={createdUtc} />
            </LabeledListItem>
            <LabeledListItem label={lt('UpdatedBy')} itemAlignment="center">
                <UserAvatar imageId={updaterProfile.imageId} name={updaterProfile.name} />
            </LabeledListItem>
            <LabeledListItem label={lt('UpdatedOn')}>
                <LocalizedDateTimeFromUtc utcString={updatedUtc} />
            </LabeledListItem>
        </DividerList>
    </ContentSection>
);
